module.exports = __webpack_public_path__ + "img/KinokoTable05.bf34be0f.jpg";